var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 7.2H17.156C17.244 6.952 17.3 6.68 17.3 6.4C17.3 5.072 16.228 4 14.9 4C14.06 4 13.332 4.432 12.9 5.08L12.5 5.616L12.1 5.072C11.668 4.432 10.94 4 10.1 4C8.772 4 7.7 5.072 7.7 6.4C7.7 6.68 7.756 6.952 7.844 7.2H6.1C5.212 7.2 4.508 7.912 4.508 8.8L4.5 17.6C4.5 18.488 5.212 19.2 6.1 19.2H18.9C19.788 19.2 20.5 18.488 20.5 17.6V8.8C20.5 7.912 19.788 7.2 18.9 7.2ZM14.9 5.6C15.34 5.6 15.7 5.96 15.7 6.4C15.7 6.84 15.34 7.2 14.9 7.2C14.46 7.2 14.1 6.84 14.1 6.4C14.1 5.96 14.46 5.6 14.9 5.6ZM10.1 5.6C10.54 5.6 10.9 5.96 10.9 6.4C10.9 6.84 10.54 7.2 10.1 7.2C9.66 7.2 9.3 6.84 9.3 6.4C9.3 5.96 9.66 5.6 10.1 5.6ZM18.9 17.6H6.1V16H18.9V17.6ZM18.9 13.6H6.1V8.8H10.164L8.5 11.064L9.796 12L11.7 9.408L12.5 8.32L13.3 9.408L15.204 12L16.5 11.064L14.836 8.8H18.9V13.6Z",
    fill: "#D337F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.b1aacd74.svg";
export { ForwardRef as ReactComponent };